
export class TServiceResult<T>
{
    TheValue: T | null = null;
    Result: boolean = false;
    Reason: string | null = null;
    CorrelationID: string = "";
    Succeeded: boolean = false;
}

export class ServiceResult
{
    Result: boolean = false;
    Reason: string | null = null;
    CorrelationID: string = "";
    Succeeded: boolean = false;
}

export const EmptyServiceResult: ServiceResult =
{
    Result: false,
    Reason: "Not initialized",
    CorrelationID: "",
    Succeeded: false
}
